<template>
  <div class="characteristics">
    <h2 class="title" v-if="characteristics">Характеристики</h2>
    <div v-if="list" class="list">
      <div class="item" v-for="(characteristic, index) in list.list" :key="index">
        <span class="subtitle" v-if="characteristic.subtitle">
          {{ characteristic.subtitle }}
        </span>
        <ul class="sublist">
          <li class="characteristic" v-for="(value, index) in characteristic.values" :key="index">
            <span class="name">{{ value.name }}</span>
            <span class="value" :class="{ value_cropped: isCropped }">{{ value.value }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue';
import type { ICharacteristics } from '../../models/characteristic';

interface PropsData {
  characteristics: ICharacteristics;
}

interface Props {
  characteristics?: ICharacteristics;
  propsData?: PropsData;
  showModalButton?: boolean;
  isCropped?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showModalButton: false,
  isCropped: false,
});

const { characteristics, propsData, isCropped } = toRefs(props);

const list = computed((): ICharacteristics => {
  return propsData.value ? propsData.value.characteristics : characteristics.value!;
});
</script>

<style lang="stylus" scoped>
.characteristics
  font-family 'Inter'

  .title
    font-weight 600
    font-size 22px
    line-height 28px
    letter-spacing -0.021em
    margin 0

  .list
    display flex
    flex-wrap wrap

    .item
      margin-top 24px
      width 100%

      .subtitle
        font-size 14px
        font-weight 600
        line-height 20px
        letter-spacing -0.011em
        margin 0

      .sublist
        display flex
        flex-direction column
        flex-wrap wrap
        //height 106px
        margin 14px 0 0 0

        .characteristic
          display grid
          grid-template-columns 2fr 1.5fr
          margin-top 12px

          .value_cropped
            overflow hidden
            -webkit-box-orient vertical
            -webkit-line-clamp 5
            display -webkit-box

          .name, .value
            font-size 14px
            font-weight 400
            line-height 20px
            letter-spacing -0.005em


          .name
            color hsla(229, 6%, 57%, 1)
  .button
    width 100%
    margin-top 32px
</style>
